

















import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class CloseIcon extends Vue {
  @Prop({ type: String, default: '16' }) size!: string
}
